var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 75,
    viewBox: "0 0 33 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 0H0V75H33V0ZM21.501 28.5316C22.0708 27.9302 22.0451 26.9808 21.4437 26.4111C20.8423 25.8413 19.8929 25.867 19.3232 26.4684L10.3232 35.9684C9.77509 36.5469 9.77509 37.4531 10.3232 38.0316L19.3232 47.5316C19.8929 48.133 20.8423 48.1587 21.4437 47.5889C22.0451 47.0192 22.0708 46.0698 21.501 45.4684L13.4784 37L21.501 28.5316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.9000790a41aa47f76f5f4fa8f28e62fe.svg";
export { ForwardRef as ReactComponent };